import script from "./RowMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./RowMenu.vue?vue&type=script&setup=true&lang=js"

import "./RowMenu.vue?vue&type=style&index=0&id=fd1959a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd1959a4"]])

export default __exports__